import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * Hook wykrywający status konfiguracji KSeF na podstawie istniejących endpointów.
 *
 * Definicja "KSeF skonfigurowany":
 *   - has_cert === true (certyfikat załadowany)
 *   - company_nip != null (NIP zapisany)
 *
 * Jeden refresh przy mount + opcjonalny refetch przy events 'ksef:config-updated'.
 * Nie tworzy nowych endpointów — używa GET /api/ksef/admin/config + GET /api/ksef/company-nip.
 */
export function useKsefStatus() {
  const [status, setStatus] = useState({ loading: true, configured: false });

  const fetchStatus = async () => {
    try {
      const [cfgRes, nipRes] = await Promise.all([
        axios.get(`${API}/ksef/admin/config`, { withCredentials: true }).catch(() => ({ data: null })),
        axios.get(`${API}/ksef/company-nip`, { withCredentials: true }).catch(() => ({ data: null })),
      ]);
      const cfg = cfgRes.data;
      const hasCert = !!cfg?.has_cert;
      const nip = nipRes.data?.company_nip || cfg?.company_nip || "";
      setStatus({ loading: false, configured: !!(hasCert && nip), nip });
    } catch (_e) {
      setStatus({ loading: false, configured: false });
    }
  };

  useEffect(() => {
    fetchStatus();
    const handler = () => fetchStatus();
    window.addEventListener("ksef:config-updated", handler);
    return () => window.removeEventListener("ksef:config-updated", handler);
  }, []);

  return status;
}
